import { Outlet } from 'react-router-dom'
import InAppMeetingPanel from '@/components/InAppMeetingPanel'
import { HelpAgentRoot } from '@/components/HelpAgent'
import ProvisionalBoardSweeper from '@/routes/IntelligentBoard/ProvisionalBoardSweeper'
import { useFeatureAccess } from '@/features/featureAccess/useFeatureAccess'
import { useAppStore } from '@/store'

// Top-level layout that wraps every route so cross-route surfaces
// (e.g. the in-app meeting PiP panel, the help agent) survive navigation.
export const RootLayout = () => {
  const { isEnabled } = useFeatureAccess()
  // A call already running keeps its panel (and its end control) even if calls get hidden.
  const callActive = useAppStore((s) => s.activeToken !== null)
  return (
    <>
      <Outlet />
      {(isEnabled('agent_calls') || callActive) && <InAppMeetingPanel />}
      {isEnabled('help_agent') && <HelpAgentRoot />}
      {/* UI-84: watches for the user leaving a board. Lives here because this
          layout survives navigation — the board canvas itself unmounts for
          reasons that are not a departure. */}
      <ProvisionalBoardSweeper />
    </>
  )
}
